// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LoadingGif_spinner__jDDQy position-absolute"};